import {combineReducers} from 'redux';

import favoriteSports from './favorite-sports';
import topTourneys from './top-tourneys';
import viewedNews from './viewed-news';
import videoModal from './video-modal';
import favorites from './favorites';
import filter from './event-filter';
import liveSoon from './live-soon';
import payments from './payments';
import oneclick from './oneclick';
import tracker from './tracker';
import result from './result';
import coupon from './coupon';
import user from './user';
import main from './main';
import live from './live';
import news from './news';
import auth from './auth';
import line from './line';
import bet from './bet';

export default combineReducers({
	favoriteSports,
	topTourneys,
	viewedNews,
	videoModal,
	favorites,
	liveSoon,
	payments,
	oneclick,
	tracker,
	coupon,
	filter,
	result,
	live,
	news,
	auth,
	main,
	user,
	line,
	bet
});


// WEBPACK FOOTER //
// ./src/app/redux/reducers/index.js